import React from "react";

const CookiePreferencesButton = ({ onClick }) => {
  return (
    <button
      type="button"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClick();
      }}
      aria-label="Cookie preferences"
      style={{
        position: "fixed",
        bottom: 24,
        left: 24,
        width: 56,
        height: 56,
        borderRadius: "50%",
        backgroundColor: "#266fee",
        color: "#fff",
        border: "none",
        cursor: "pointer",
        zIndex: 9999,
        boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 22,
      }}
    >
      🍪
    </button>
  );
};

export default CookiePreferencesButton;